// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"56":"offer_page","95":"faq_page","473":"main_page","923":"old_main_page"}[chunkId] || chunkId) + "." + {"56":"bf053b44","95":"20b9e1ac","100":"31af41a8","147":"c5bd1145","473":"ea6ecb50","580":"fd09df0a","921":"b53d047d","923":"e71606a5"}[chunkId] + ".chunk.js";
};